import type Handlebars from 'handlebars'

type HandlebarsInstance = typeof Handlebars

/**
 * Formate un montant selon la locale et la devise.
 * Usage : {{formatPrice 19.99 "EUR" "fr-FR"}}
 * Si locale/currency sont omis, utilise les valeurs passées au registre.
 */
export function registerPriceHelpers(
  hbs: HandlebarsInstance,
  defaults: { locale: string; currency: string }
): void {
  hbs.registerHelper(
    'formatPrice',
    function (
      value: unknown,
      currency?: unknown,
      locale?: unknown
    ): string {
      const amount = typeof value === 'number' ? value : parseFloat(String(value))
      if (isNaN(amount)) return ''

      const resolvedCurrency =
        typeof currency === 'string' ? currency : defaults.currency
      const resolvedLocale =
        typeof locale === 'string' ? locale : defaults.locale

      return new Intl.NumberFormat(resolvedLocale, {
        style: 'currency',
        currency: resolvedCurrency,
      }).format(amount)
    }
  )

  hbs.registerHelper(
    'formatPriceCompact',
    function (value: unknown, currency?: unknown, locale?: unknown): string {
      const amount = typeof value === 'number' ? value : parseFloat(String(value))
      if (isNaN(amount)) return ''

      const resolvedCurrency =
        typeof currency === 'string' ? currency : defaults.currency
      const resolvedLocale =
        typeof locale === 'string' ? locale : defaults.locale

      return new Intl.NumberFormat(resolvedLocale, {
        style: 'currency',
        currency: resolvedCurrency,
        notation: 'compact',
      }).format(amount)
    }
  )

  hbs.registerHelper(
    'discountPercent',
    function (original: unknown, discounted: unknown): string {
      const orig = typeof original === 'number' ? original : parseFloat(String(original))
      const disc = typeof discounted === 'number' ? discounted : parseFloat(String(discounted))
      if (isNaN(orig) || isNaN(disc) || orig === 0) return ''
      const pct = Math.round(((orig - disc) / orig) * 100)
      return `-${pct}%`
    }
  )
}
